import React from 'react';
import { Menu } from 'antd';
import { SelectParam } from 'antd/lib/menu';

interface Props {
    value?: string,
    onChange: (value: string) => void,
}

function RankSelectField({
    value,
    onChange 
}: Props) {

  const handleChange = (data: SelectParam) => {
    onChange(data.key);
  };

  return (
    <Menu
      selectedKeys={value ? [value] : []}
      onSelect={handleChange}
      onDeselect={handleChange}
      style={{ margin: '-16px', border: 'none' }}
    >
      <Menu.Item key="bronze">
        Бронза
      </Menu.Item>
      <Menu.Item key="silver">
        Серебро
      </Menu.Item>
      <Menu.Item key="gold">
        Золото
      </Menu.Item>
      <Menu.Item key="platinum">
        Платина
      </Menu.Item>
      <Menu.Item key="vip">
        VIP
      </Menu.Item>
    </Menu>
  );
}

export default RankSelectField;